export default __webpack_public_path__ + "static/media/poultry_cat.ec80bf06.jpg";